import { trimString } from '@/utils/text';

const ANIMAL_STATUS = {
  ACTIVE: 'active',
  ALIVE: 'alive',
  OVERSEAS_ACTIVE: 'overseas active',
} as const;

export const ANIMAL_STATUS_TONE = {
  SUCCESS: 'success',
  NEUTRAL: 'neutral',
} as const;

/**
 * As the value for this can be anything, this includes common options but not all
 * @param value
 */
function isAnimalCurrentlyAlive(value: string | null | undefined) {
  const normalized = trimString(value).toLowerCase();
  return (
    normalized === ANIMAL_STATUS.ACTIVE ||
    normalized === ANIMAL_STATUS.ALIVE ||
    normalized === ANIMAL_STATUS.OVERSEAS_ACTIVE
  );
}

/**
 * Maps an animal status string to a display tone.
 * - `'success'` — alive/active statuses (active, alive, overseas active)
 * - `'neutral'` — everything else
 */
export function getAnimalStatusTone(value: string | null | undefined) {
  if (isAnimalCurrentlyAlive(value)) return ANIMAL_STATUS_TONE.SUCCESS;
  return ANIMAL_STATUS_TONE.NEUTRAL;
}
